import { useStyles } from './UpcomingDetailsInfo.styles';
import { Grid, GridVariant } from 'app/shared/components/generic-ui';
import { CustomTypography } from 'app/shared/components/generic-ui/Typography/Typography';
import { IUpcomingPourEventResponse } from 'types';
import { useUpcomingDetailsInfoValues } from './useUpcomingDetailsInfoValues';
import { UpcomingBatchItem } from './UpcomingBatchItem';

interface IUpcomingDetailsInfoProps {
  upcomingPourEvent: IUpcomingPourEventResponse;
}

export const UpcomingDetailsInfo = ({
  upcomingPourEvent,
}: IUpcomingDetailsInfoProps) => {
  const { classes } = useStyles();
  const { upcomingDetailsInfoValues } =
    useUpcomingDetailsInfoValues(upcomingPourEvent);

  return (
    <div className={classes.info}>
      {upcomingDetailsInfoValues.map(section => (
        <div
          style={{ display: 'flex', flexDirection: 'column' }}
          key={section.title}
        >
          <div className={classes.subheader}>
            <CustomTypography variant="header6" bold color="accentDark">
              {section.title}
            </CustomTypography>
          </div>

          <Grid container spacing={1}>
            {section.content.map(el => (
              <div key={el.label} className={classes.sectionItem}>
                <Grid item variant={GridVariant.MEDIUM}>
                  <CustomTypography variant="caption2" bold color="greyscale2">
                    {el.label}
                  </CustomTypography>
                </Grid>
                <Grid
                  item
                  variant={GridVariant.MEDIUM}
                  className={classes.valueContainer}
                >
                  <CustomTypography variant="bodySmall" color="accentDark">
                    {el.value}
                  </CustomTypography>

                  {el?.age ? (
                    <div
                      className={classes.ageContainerLight}
                      style={{ marginLeft: el.value ? 5 : 0 }}
                    >
                      <CustomTypography variant="caption2" color="accentLight">
                        {el.age}
                      </CustomTypography>
                    </div>
                  ) : null}
                </Grid>
              </div>
            ))}
          </Grid>
        </div>
      ))}
      <div>
        <div className={classes.subheader}>
          <CustomTypography variant="header6" bold color="accentDark">
            Order Schedules
          </CustomTypography>
        </div>

        {upcomingPourEvent.scheduleModels.map(schedule => (
          <div key={schedule.crn}>
            <UpcomingBatchItem schedule={schedule} />
          </div>
        ))}
      </div>
    </div>
  );
};
